import { useState } from 'react';
import { Cake } from 'lucide-react';
import { setStudentBirthYm } from '../../shared/api/birthYm';
import BirthYmPicker from './BirthYmPicker';
import { formatBirthYm, BIRTH_YM_EXPLAINER } from './childAge';
import './BirthYm.css';

/**
 * Settings → 出生年月 (worded for anyone: adults use the app too). One row a parent can set or change; tells them what the
 * age is used for, so it never reads as data collection for its own sake.
 *
 * @param {{ studentId: string, birthYm: string|null, onSaved: (birthYm: string|null) => void }} props
 */
export default function BirthYmSection({ studentId, birthYm, onSaved }) {
  const [editing, setEditing] = useState(false);

  const save = async (ym) => {
    const res = await setStudentBirthYm(studentId, ym);
    onSaved(res.birthYm);
    setEditing(false);
  };

  return (
    <section className="settings-section birth-ym-section">
      <div className="birth-ym-section__head">
        <Cake size={18} className="settings-install-icon" />
        <span className="settings-install-label">出生年月</span>
        {birthYm && !editing && (
          <button type="button" className="birth-ym-section__edit" onClick={() => setEditing(true)}>修改</button>
        )}
      </div>
      {birthYm && !editing
        ? <p className="birth-ym-section__value">{formatBirthYm(birthYm)}</p>
        : (
          <BirthYmPicker
            idPrefix="settings-birth-ym"
            value={birthYm}
            onSave={save}
            onCancel={birthYm ? () => setEditing(false) : undefined}
          />
        )}
      <p className="birth-ym-section__why">{BIRTH_YM_EXPLAINER}老师也可以在班级里设置。</p>
    </section>
  );
}
